import { Match } from '../api-client/sport-bo-api';

export const getCellId = (match: Match, cellName: string): string => {
  return `${match.id!}-${cellName}`;
};
